import React from "react";
import { Fade } from "react-awesome-reveal";
import Whats from "./Whats";
import "../styles/Services.scss";
import img1 from "../images/services/1.png";
import img2 from "../images/services/2.png";

const Services = () => {
  const servicios = [
    {
      id: 1,
      imagen: img1,
      titulo: "Clases de Inglés para Juniors (11 a 14 años)",
      texto:
        'Ofrecemos un programa diseñado especialmente para estudiantes de secundaria que quieren aprender inglés de manera real, práctica y efectiva. Nuestro método se enfoca en la conversación, la comprensión auditiva y el uso cotidiano del idioma, lo que permite avances visibles desde las primeras semanas. Las clases se imparten dos veces por semana, en grupos pequeños para garantizar atención personalizada. El curso incluye libro, seguimiento con nuestro sistema exclusivo y un enfoque divertido que mantiene a los jóvenes motivados. En solo un año, tu hijo podrá hablar inglés con fluidez, gracias a una estructura clara, dinámica y orientada a resultados. Todo esto con el mejor costo-beneficio del mercado, desde nuestra sede en San José del Cabo.',
    },
    {
      id: 2,
      imagen: img2,
      titulo: "Clases de Inglés para Jovenes y Adultos",
      texto:
        "Sabemos que el tiempo es uno de los mayores obstáculos para aprender inglés, especialmente si tienes trabajo, escuela o un horario rolado. Por eso, diseñamos un sistema con grupos paralelos, donde puedes recuperar tus clases sin perder el ritmo de aprendizaje. Nuestro método está centrado en la práctica conversacional y el entrenamiento auditivo, lo que te permite hablar inglés correcto y fluido en solo 8 meses. Además, nuestros grupos son reducidos para ofrecer atención personalizada y seguimiento constante. No dejes que el idioma siga siendo una barrera. Hoy más que nunca, hablar inglés abre puertas laborales y profesionales reales. Nuestro sistema está comprobado por cientos de alumnos que ya lograron resultados en poco tiempo, con la mejor relación costo-beneficio del mercado. Contáctanos hoy y asegura tu lugar. Aprender inglés nunca había sido tan flexible, efectivo y alcanzable.",
    },
  ];

  return (
    <div id="allServices" className="mt-2">
      <h4 className="fw-bold fs-3 title">NUESTRAS CLASES</h4>
      {servicios.map((servicio) => (
        <section
          className="cursosContainer"
          id={"servicio" + servicio.id}
          key={servicio.id}
        >
          <div className="imgContainer text-center">
            <Fade duration="1000">
              <img src={servicio.imagen} alt={servicio.titulo} />
            </Fade>
          </div>
          <div className="infoCursoContainer">
            <Fade duration="1000">
              <span id={"titleService" + servicio.id} className="titleService">
                <strong>{servicio.titulo}</strong>
              </span>
            </Fade>
            <span id={"textService" + servicio.id} className="textService">{servicio.texto}</span>

            <div className="btnServiceContainer">
              <Whats
                classStyle="btn btnService"
                phoneNumber="5216241270773"
                message={`¡Me pudiera brindar más información acerca de ${servicio.titulo}!`}
                text="¡Más información!"
              />
            </div>
          </div>
        </section>
      ))}
    </div>
  );
};

export default Services;
